import { useSnapshot } from 'valtio';
import { frontEndSettingsState } from '../state';

export function useContactCenterSettings() {
  const settings = useSnapshot(frontEndSettingsState.contactCenterSettings);

  return settings;
}
